'use client';

import { c as _c } from "react/compiler-runtime";
import { Xmark } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { Button } from '~/components/Button';
import styles from './OverlayDrawer.module.css';
import type { OverlayDrawerProps } from './OverlayDrawer.types';
export function OverlayDrawer(t0) {
  const $ = _c(28);
  const {
    ariaLabel,
    children,
    close,
    isOpen: t1,
    headerContent,
    maxWidth: t2,
    ref,
    dataTestId: t3
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const maxWidth = t2 === undefined ? "none" : t2;
  const dataTestId = t3 === undefined ? "dialog" : t3;
  const t = useTranslations("aria");
  const t4 = typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth;
  let t5;
  if ($[0] !== t4) {
    t5 = {
      "--overlay-drawer-max-width": t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[2] !== children) {
    t7 = <div className={styles.content}>{children}</div>;
    $[2] = children;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== headerContent) {
    t8 = headerContent ? <div className={styles.headerContent}>{headerContent}</div> : null;
    $[4] = headerContent;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t) {
    t9 = t("close");
    $[6] = t;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Xmark decorative={true} size="large" />;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== close || $[10] !== t9) {
    t11 = <span className={styles.closeButton}><Button variant="icon" ariaLabel={t9} onPress={close}>{t10}</Button></span>;
    $[9] = close;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t8) {
    t12 = <div className={styles.header}>{t8}{t11}</div>;
    $[12] = t11;
    $[13] = t8;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== ariaLabel || $[16] !== dataTestId || $[17] !== t12 || $[18] !== t7) {
    t13 = <Dialog className={styles.dialog} aria-label={ariaLabel} data-test-id={dataTestId}>{t7}{t12}</Dialog>;
    $[15] = ariaLabel;
    $[16] = dataTestId;
    $[17] = t12;
    $[18] = t7;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== ref || $[21] !== t13 || $[22] !== t6) {
    t14 = <Modal ref={ref} className={styles.modal} style={t6}>{t13}</Modal>;
    $[20] = ref;
    $[21] = t13;
    $[22] = t6;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== close || $[25] !== isOpen || $[26] !== t14) {
    t15 = <ModalOverlay className={styles.modalOverlay} isDismissable={true} isOpen={isOpen} onOpenChange={close}>{t14}</ModalOverlay>;
    $[24] = close;
    $[25] = isOpen;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
}